import { ModelTrainingCourse } from 'api/api';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { IAuthModel } from 'utilities/auth';

const header = atom({
    title: '',
    showSearch: false,
    showBackBtn: false,
    searchValue: '',
});

const course = atom<ModelTrainingCourse>({});

const sessionAuth = localStorage.getItem('auth');
const sessionAuthModel =
    sessionAuth && sessionAuth.length > 0
        ? (JSON.parse(sessionAuth) as IAuthModel)
        : undefined;

const authAtom = atom<IAuthModel>(
    sessionAuthModel || {
        token: '',
        isLoading: false,
        isSuccessful: false,
        error: '',
        resp: {},
    }
);
const insufficientBalanceModalOpen = atom<boolean>(false);
const planLimitModal = atom<boolean>(false);

const theme = atomWithStorage<string>('theme', 'light');
export const jotaiStore = {
    header,
    course,
    authAtom,
    theme,
    insufficientBalanceModalOpen,
    planLimitModal,
};
